import { TreeNode } from "../../utils/data-structures/tree-node"
import "../../utils/extensions"
import { Chord } from "./music-models"
import { Chord as TonalChord, Note, Progression } from "@tonaljs/tonal"

// Helper para crear nodo de acorde (reemplaza .node() de String.prototype)
function createChordNode(chordSymbol: string, isLeaf: boolean): TreeNode<Chord> {
   const node = new TreeNode<Chord>(
      new Chord({
         notes: Progression.fromRomanNumerals("C", [chordSymbol])
            .map((note) => TonalChord.get(note).notes)[0]
            .map((note) => (Note.get(`${note}0`).midi as number) - 6)
            .sort((a, b) => a - b),
         label: chordSymbol,
      }),
      isLeaf
   )
   if (node.value.notes.length === 0) {
      console.log("Problem with chord: " + node.value.label)
   }
   return node
}

export const progressions_list: string[] = [
   // ===== CLÁSICA / BARROCA (Bach, Vivaldi) =====
   "I V6/4 V I",
   "I IV V I",
   "I V6/5 I V I",
   "I V4/3 I6 V I",
   "I vi ii6 V I",
   "I I6 IV V6/5 I",
   "I6 ii6 V I",
   "I V6/5/vi vi V6/5/ii ii V6/5 V I",
   "I V4/3 I6 IV V I",
   "vi IV6 I6 V",
   "I vi6 ii6 V",
   "I IV vii° iii vi ii V I",
   "I V vi iii IV I ii V",
   
   // ===== ROMÁNTICA (Beethoven, Chopin, Schubert) =====
   "I bIII I",
   "I bVI bII I",
   "I vi bVI V",
   "I vi ii°7/V V",
   "I vi IV V",
   "I V6/vi vi ii6 V",
   "I bVII bVI V",
   "I bIII IV V",
   "Imaj7 vi7 ii7 V7",
   "I V4/2 vi6 ii6 V I",
   "I bII7 I",
   "I vi bVI V",
   
   // ===== POPULAR OCCIDENTAL =====
   "I V vi IV",
   "I V vi iii IV I ii V",
   "vi IV I V",
   "vi V IV V",
   "I V6 vi IV",
   "Imaj7 vi7 ii7 V7",
   "I V vi ii IV V",
   "I IV V",
   "I V IV",
   "I bVII IV I",
   "I V vi iii IV I ii V",
   "I IV vi V",
   "I V vi IV I V I",
   
   // ===== JAZZ Y STANDARDS =====
   "ii7 V7 Imaj7",
   "ii7 V7 I6",
   "ii7b5 V7b9 Im7",
   "Imaj7 ii7 V7 I6",
   "I vi ii V",
   "I I7 IV iv",
   "I V/vi vi V/ii ii V I",
   "I V7/ii ii V7/iii iii VI7 ii V7 I",
   "Imaj7 vi7 ii7 V7",
   "Imaj7 IV7 iii7 vi7 ii7 V7 I",
   
   // ===== PREMIUM (Lo mejor de todo) =====
   "I V vi iii IV I IV V",
   "I V vi iii IV I ii V",
   "I vi IV V",
   "I V vi iii IV I ii V",
   "I V6/5 I6 IV V I",
   "I V I",
   "I IV V I",
   "I V6 I6 IV I6/4 V I",
   "Imaj7 II7 Imaj7 V7sus4",
   "I V6/4 vi ii6 V I",
   "Imaj7 vi7 ii7 V7 I6",
]

export function convertToTree(progressions: string[]): TreeNode<Chord> {
   const root: TreeNode<Chord> = TreeNode.root()
   Array.from(new Set(progressions)).forEach((progression) => {
      let currentNode = root
      progression
         .split(" ")
         .map((chord, index, array) => createChordNode(chord, index === array.length - 1))
         .forEach((chord) => {
            const next = currentNode.children.find((child) => child.value.label === chord.value.label && !child.isLeaf)
            if (next && !chord.isLeaf) {
               currentNode = next
            } else {
               currentNode.children.push(chord)
               currentNode = chord
            }
         })
   })
   return root
}
